import { useState } from "react";
import { useLocation } from "wouter";

const PRIMARY_COLOR = "hsl(var(--primary))";

export default function Simulator() {
  const [email, setEmail] = useState("");
  const [, navigate] = useLocation();
  return (
    <div className="w-full h-full flex items-center justify-center p-4 md:p-8">
      <div className="w-full p-8 md:p-16 relative bg-white rounded-3xl outline outline-1 outline-offset-[-1px] outline-slate-500/5 flex flex-col items-center gap-10">
        {/* Subtle purple shadow overlay */}
        <div className="absolute inset-0 bg-white/0 rounded-3xl shadow-[0px_8px_10px_-6px_hsl(var(--primary)/0.05),0px_20px_25px_-5px_hsl(var(--primary)/0.05)] pointer-events-none" />

        {/* Leaf Icon */}
        <div className="relative z-10 w-28 h-28 bg-primary/10 rounded-full flex justify-center items-center">
          <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 36.4808C4.125 34.6058 2.65625 32.4391 1.59375 29.9808C0.53125 27.5224 0 24.9808 0 22.3558C0 19.7308 0.5 17.137 1.5 14.5745C2.5 12.012 4.125 9.60577 6.375 7.35577C7.83333 5.89744 9.63542 4.64744 11.7812 3.60577C13.9271 2.5641 16.4688 1.74119 19.4062 1.13702C22.3438 0.532853 25.6979 0.168269 29.4688 0.0432692C33.2396 -0.0817308 37.4583 0.0641026 42.125 0.480769C42.4583 4.89744 42.5625 8.95994 42.4375 12.6683C42.3125 16.3766 41.9688 19.7204 41.4062 22.6995C40.8438 25.6787 40.0521 28.2829 39.0312 30.512C38.0104 32.7412 36.75 34.6058 35.25 36.1058C33.0417 38.3141 30.6979 39.9287 28.2188 40.9495C25.7396 41.9704 23.2083 42.4808 20.625 42.4808C17.9167 42.4808 15.2708 41.9495 12.6875 40.887C10.1042 39.8245 7.875 38.3558 6 36.4808ZM13 35.4808C14.2083 36.1891 15.4479 36.6995 16.7188 37.012C17.9896 37.3245 19.2917 37.4808 20.625 37.4808C22.5417 37.4808 24.4375 37.0954 26.3125 36.3245C28.1875 35.5537 29.9792 34.3141 31.6875 32.6058C32.4375 31.8558 33.1979 30.8037 33.9688 29.4495C34.7396 28.0954 35.4062 26.3245 35.9688 24.137C36.5312 21.9495 36.9583 19.3037 37.25 16.1995C37.5417 13.0954 37.5833 9.39744 37.375 5.10577C35.3333 5.02244 33.0312 4.99119 30.4688 5.01202C27.9062 5.03285 25.3542 5.23077 22.8125 5.60577C20.2708 5.98077 17.8542 6.58494 15.5625 7.41827C13.2708 8.2516 11.3958 9.39744 9.9375 10.8558C8.0625 12.7308 6.77083 14.5849 6.0625 16.4183C5.35417 18.2516 5 20.0224 5 21.7308C5 24.1891 5.46875 26.3454 6.40625 28.1995C7.34375 30.0537 8.16667 31.3558 8.875 32.1058C10.625 28.7724 12.9375 25.5745 15.8125 22.512C18.6875 19.4495 22.0417 16.9391 25.875 14.9808C22.875 17.6058 20.2604 20.5745 18.0312 23.887C15.8021 27.1995 14.125 31.0641 13 35.4808Z" fill={PRIMARY_COLOR}/>
          </svg>
        </div>

        {/* Heading & Subtitle */}
        <div className="relative z-10 flex flex-col items-center gap-4">
          <h1 className="text-4xl md:text-5xl font-black text-primary text-center leading-tight">
            {"Coming Soon"}
          </h1>
          <p className="text-center text-slate-500 text-lg md:text-xl leading-7">
            {"This feature is currently under development"}
          </p>
        </div>

        {/* Email + CTA */}
        <div className="relative z-10 flex flex-col items-center gap-8 pb-6 w-full">
          <div className="w-full max-w-96 p-1.5 bg-neutral-100 rounded-3xl outline outline-1 outline-offset-[-1px] outline-slate-500/10 flex items-center">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={"Enter your email"}
              className="flex-1 px-4 py-3.5 bg-transparent text-slate-700 placeholder:text-slate-400 text-base outline-none"
            />
            <button className="px-6 py-3 bg-primary hover:bg-primary/90 transition-colors rounded-2xl text-primary-foreground text-base font-bold whitespace-nowrap">
              {"Get notified"}
            </button>
          </div>

          {/* Back to Dashboard */}
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-800 transition-colors"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.1875 7.5L7.85417 12.1667L6.66667 13.3333L0 6.66667L6.66667 0L7.85417 1.16667L3.1875 5.83333H13.3333V7.5H3.1875Z" fill="currentColor"/>
            </svg>
            <span className="text-base font-medium">
              {"Back to dashboard"}
            </span>
          </button>
        </div>

        {/* Feature Cards */}
        <div className="relative z-10 w-full pt-12 border-t border-slate-500/5 flex flex-col md:flex-row justify-center items-start gap-6">
          {/* AI Forecasting */}
          <div className="flex-1 flex flex-col items-center gap-2">
            <div className="w-10 h-10 mb-2 bg-primary/5 rounded-3xl flex justify-center items-center">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H10ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 10.3833 2.025 10.7583 2.075 11.125C2.125 11.4917 2.2 11.85 2.3 12.2L6 8.5L9.3 11.275L12.575 8H11V6H16V11H14V9.425L9.4 14L6.125 11.2L3.175 14.15C3.875 15.3 4.82083 16.2292 6.0125 16.9375C7.20417 17.6458 8.53333 18 10 18ZM17.5 18.5C17.7833 18.5 18.0208 18.4042 18.2125 18.2125C18.4042 18.0208 18.5 17.7833 18.5 17.5C18.5 17.2167 18.4042 16.9792 18.2125 16.7875C18.0208 16.5958 17.7833 16.5 17.5 16.5C17.2167 16.5 16.9792 16.5958 16.7875 16.7875C16.5958 16.9792 16.5 17.2167 16.5 17.5C16.5 17.7833 16.5958 18.0208 16.7875 18.2125C16.9792 18.4042 17.2167 18.5 17.5 18.5Z" fill={PRIMARY_COLOR}/>
              </svg>
            </div>
            <span className="text-center text-slate-800 text-base font-bold">
              {"Forecasting"}
            </span>
            <p className="text-center text-slate-500 text-xs leading-4">
              {"Forecast trends and plan ahead."}
            </p>
          </div>

          {/* Supply Chain Mapping */}
          <div className="flex-1 flex flex-col items-center gap-2">
            <div className="w-10 h-10 mb-2 bg-primary/5 rounded-3xl flex justify-center items-center">
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 18V15H9V5H7V8H0V0H7V3H13V0H20V8H13V5H11V13H13V10H20V18H13ZM15 6H18V2H15V6ZM15 16H18V12H15V16ZM2 6H5V2H2V6Z" fill={PRIMARY_COLOR}/>
              </svg>
            </div>
            <span className="text-center text-slate-800 text-base font-bold">
              {"Supply Chain"}
            </span>
            <p className="text-center text-slate-500 text-xs leading-4">
              {"Monitor supply chain risks and bottlenecks."}
            </p>
          </div>

          {/* ESG Compliance */}
          <div className="flex-1 flex flex-col items-center gap-2">
            <div className="w-10 h-10 mb-2 bg-primary/5 rounded-3xl flex justify-center items-center">
              <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.6 21L5.7 17.8L2.1 17L2.45 13.3L0 10.5L2.45 7.7L2.1 4L5.7 3.2L7.6 0L11 1.45L14.4 0L16.3 3.2L19.9 4L19.55 7.7L22 10.5L19.55 13.3L19.9 17L16.3 17.8L14.4 21L11 19.55L7.6 21ZM8.45 18.45L11 17.35L13.6 18.45L15 16.05L17.75 15.4L17.5 12.6L19.35 10.5L17.5 8.35L17.75 5.55L15 4.95L13.55 2.55L11 3.65L8.4 2.55L7 4.95L4.25 5.55L4.5 8.35L2.65 10.5L4.5 12.6L4.25 15.45L7 16.05L8.45 18.45ZM9.95 14.05L15.6 8.4L14.2 6.95L9.95 11.2L7.8 9.1L6.4 10.5L9.95 14.05Z" fill={PRIMARY_COLOR}/>
              </svg>
            </div>
            <span className="text-center text-slate-800 text-base font-bold">
              {"Compliance"}
            </span>
            <p className="text-center text-slate-500 text-xs leading-4">
              {"Track policy and requirement compliance."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
